<template>
  <div class="my-4">
    <div class="container-fluid px-2">
      <table class="table table-hover table-sm">
        <thead>
          <tr>
            <td scope="col" class="text-center">Day</td>
            <td scope="col">Title</td>
            <td scope="col" class="text-center">Line breaks</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(day, index) in data"
            :key="index"
            :class="{ 'isHighlighted': Number(day.line_breaks_number) > 0 }">
            <th class="text-center align-middle text-bold">{{ day.startday }}</th>
            <td class="text-left align-middle" v-html="day.title"></td>
            <td class="text-center align-middle">
              <BaseSelect
                style="width: 80px;margin: auto;"
                v-if="index != 0"
                v-model="day.line_breaks_number"
                :options="lineBreaksNumber"
                :disabled="isSaving"
                :isSmallSize="true" />
              <div v-else style="height: 30px;">&nbsp;</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TabShareLineBreaksNumber',
  props: {
    data: {
      type: Array,
      required: true
    },
    isSaving: {
      type: Boolean,
      required: true
    },
    maxLineBreaks: {
      type: Number,
      default: 10
    }
  },
  computed: {
    lineBreaksNumber () {
      return new Array(this.maxLineBreaks + 1)
        .fill()
        .map((l, i) => ({ value: i, text: i }))
    }
  }
}
</script>

<style lang="scss" scoped>
.isHighlighted {
  background-color: #FFFACD;
}
</style>
